var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { EventViewState } from 'globals/enums';
import { CLOSE_EVENT, CREATE_SUMMARY, MAXIMIZE_EVENT, MINIMIZE_EVENT, CREATE_ALERT, CREATE_MILESTONE, REMOVE_ALL_EVENTS, UPDATE_FACILITY_SUMMARY_LIST, CREATE_WELLNESS_SUMMARY, CREATE_ASSESSMENT_SUMMARY, } from './Events.action';
import { intialStateEvents, } from './Events.state';
import { UPDATE_IS_RENDER_LOCATION } from './locationData.action';
var EVENTS_STORAGE_KEY = 'app_events_notifications';
// Load persisted state from sessionStorage
var loadPersistedState = function () {
    try {
        var serializedState = sessionStorage.getItem(EVENTS_STORAGE_KEY);
        if (serializedState === null) {
            return intialStateEvents;
        }
        return JSON.parse(serializedState);
    }
    catch (err) {
        console.error('Failed to load events from sessionStorage', err);
        return intialStateEvents;
    }
};
// Save state to sessionStorage
var saveStateToSessionStorage = function (state) {
    try {
        var serializedState = JSON.stringify(state);
        sessionStorage.setItem(EVENTS_STORAGE_KEY, serializedState);
    }
    catch (err) {
        console.error('Failed to save events to sessionStorage', err);
    }
};
var eventsReducer = function (state, 
// state: IEventsInitialState = intialStateEvents,
action) {
    var _a, _b, _c, _d, _e;
    if (state === void 0) { state = loadPersistedState(); }
    var newState;
    switch (action.type) {
        case CREATE_SUMMARY:
            newState = __assign(__assign({}, state), { summary: __assign(__assign({}, state.summary), action.payload.summaryData) });
            break;
        case CREATE_WELLNESS_SUMMARY:
            newState = __assign(__assign({}, state), { wellnessPlan: __assign(__assign({}, state.wellnessPlan), action.payload.wellnessPlan) });
            break;
        case CREATE_ASSESSMENT_SUMMARY:
            newState = __assign(__assign({}, state), { assessment: __assign(__assign({}, state.assessment), action.payload.assessment) });
            break;
        case CREATE_ALERT:
            newState = __assign(__assign({}, state), { alert: __assign(__assign({}, state.alert), action.payload.alertData) });
            break;
        case CREATE_MILESTONE:
            newState = __assign(__assign({}, state), { milestone: __assign(__assign({}, state.milestone), action.payload.milestoneData) });
            break;
        case MINIMIZE_EVENT:
            newState = __assign(__assign({}, state), (_a = {}, _a[action.payload.eventType] = __assign(__assign({}, state[action.payload.eventType]), (_b = {}, _b[action.payload.eventId] = __assign(__assign(__assign({}, state[action.payload.eventType][action.payload.eventId]), action.payload.data), { viewState: EventViewState.Minimize }), _b)), _a));
            break;
        case MAXIMIZE_EVENT:
            newState = __assign(__assign({}, state), (_c = {}, _c[action.payload.eventType] = __assign(__assign({}, state[action.payload.eventType]), (_d = {}, _d[action.payload.eventId] = __assign(__assign({}, state[action.payload.eventType][action.payload.eventId]), { viewState: EventViewState.Maximize }), _d)), _c));
            break;
        case CLOSE_EVENT:
            newState = __assign(__assign({}, state), (_e = {}, _e[action.payload.eventType] = action.payload.updatedEvent, _e));
            break;
        case REMOVE_ALL_EVENTS:
            newState = __assign({}, intialStateEvents);
            sessionStorage.removeItem(EVENTS_STORAGE_KEY);
            return newState;
        case UPDATE_IS_RENDER_LOCATION:
            newState = __assign(__assign({}, state), { isRenderLocation: action.payload });
            break;
        case UPDATE_FACILITY_SUMMARY_LIST:
            newState = __assign(__assign({}, state), { facilitySummary: __spreadArray([], (action.payload || []), true) });
            break;
        default:
            return state;
    }
    // Save to sessionStorage after every state change
    saveStateToSessionStorage(newState);
    return newState;
};
export default eventsReducer;
